import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { MultipleSelect } from '../../../commons/components';

const PaymentTypeFilter = memo(({ activeFilter, filters, handler }) => {
  return (
    <MultipleSelect
      name="paymentType"
      options={filters}
      value={activeFilter}
      label="Tipo de pago"
      onChange={handler}
      customWidth={320}
    />
  );
});

PaymentTypeFilter.propTypes = {
  activeFilter: PropTypes.arrayOf(String).isRequired,
  handler: PropTypes.func.isRequired,
  filters: PropTypes.arrayOf(String).isRequired,
};

export default PaymentTypeFilter;
